module.exports = __webpack_public_path__ + "static/media/img1.e66dc14d.jpg";